/**
 * Limits shared by every config-table listing, all three derived from the
 * backend rather than chosen for looks.
 */

/** Backend caps `size` at 1–100 (`PageParams` in agentic-config's common
 *  models); 101 is a `422`, so the service clamps rather than forwarding a page
 *  size that would fail the request. */
export const CONFIG_TABLE_MAX_PAGE_SIZE = 100;

/** Page sizes offered in the paginator. Capped at the backend's limit above. */
export const CONFIG_TABLE_PAGE_SIZE_OPTIONS = [25, 50, 100];

/** Default rows per page. */
export const CONFIG_TABLE_DEFAULT_PAGE_SIZE = 25;
